<template>
  <Toast
    :position="position"
    :group="group"
  >
    <slot />
  </Toast>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import Toast from "./Toast.vue";
import { toastPositionForPath } from "./toastStyle";

const group = ref<string | undefined>(undefined);
const route = useRoute();
const position = computed(() => toastPositionForPath(route.path));
</script>
